import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-teachings"
export default class extends Controller {
  static targets = ["teachers", "teachingInstructors", "assigning"]

  initialize() {
    this.toggleChargerIdSelect(this.assigningTarget.value)
  }

  changeAssigning(event) {
    this.toggleChargerIdSelect(event.target.value)
  }

  toggleChargerIdSelect(assigningValue) {
    if (assigningValue == 'teaching_instructor') {
      this.teachersTarget.querySelectorAll('select').forEach(el => el.disabled = true)
      this.teachersTarget.classList.add('d-none')
      this.teachingInstructorsTarget.querySelectorAll('select').forEach(el => el.disabled = false)
      this.teachingInstructorsTarget.classList.remove('d-none')
    } else {
      this.teachingInstructorsTarget.querySelectorAll('select').forEach(el => el.disabled = true)
      this.teachingInstructorsTarget.classList.add('d-none')
      this.teachersTarget.querySelectorAll('select').forEach(el => el.disabled = false)
      this.teachersTarget.classList.remove('d-none')
    }
  }
}
